import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { StorageAuthService } from '../../services/storage-auth/storage-auth.service';
import { NavigationPipe } from '../../pipes/navigation/navigation.pipe';
import { ToasterService } from '@mars/ui-components';
import { TranslocoService } from '@jsverse/transloco';

/**
 * Factory function to create storage guards that check for OTP_ID and OTP_TOKEN
 * @param redirectPath - The path to redirect to if validation fails
 * @returns A CanActivateFn guard function
 */
export const createStorageGuard = (redirectPath: string): CanActivateFn => {
  return () => {
    const storageAuthService = inject(StorageAuthService);
    const router = inject(Router);
    const toastrService = inject(ToasterService);
    const translocoService = inject(TranslocoService);
    const navigationPipe = new NavigationPipe();

    const token = storageAuthService.getOtpToken();

    if (!token) {
      toastrService.warning(translocoService.translate('auth_session_expired'));
      router.navigate(['/' + navigationPipe.transform(redirectPath)]);
      return false;
    }

    return true;
  };
};
